import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { EndpointsAdmin } from '@/admin/services/_endpoints.admin'
import axios from 'axios'
import { SimpleProjectDto } from '@/models/dtos/simpleProjectDto'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import { PaginationHelper } from '@/helpers/paginationHelper'

export abstract class ProjectAdminService {
  static async getAll(currentPage?: number, pageSize?: number): Promise<PagedResponseDto<SimpleProjectDto>> {
    const pagination = PaginationHelper.getModel(currentPage, pageSize)
    const result = await axios
      .get<BaseResponseDto<PagedResponseDto<SimpleProjectDto>>>(EndpointsAdmin.project.getAll, {
        params: {
          ...pagination
        }
      })

    if (!result.data.dto) throw new Error('Cannot get data')

    return result.data.dto
  }

  static async remove(id: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(EndpointsAdmin.project.remove, {
        params: {
          id
        }
      })
  }
}
